import ValidationDetails from './validationDetails.view.js';

export default ValidationDetails;
